import { useCallback } from 'react';
import PresentationContainer from 'react-presentation-container';
import { useMutation, useQueryClient } from 'react-query';
import get from 'lodash/get';
import AuthService from '@/services/auth.service';
import routerMiddleware from '@/core/router-middleware';
import ROUTES from '@/routes';

import Login from './Login.component';

export default PresentationContainer({
  component: Login,
  middleware: [routerMiddleware()],
  controller: function LoginController({ history }) {
    const queryClient = useQueryClient();
    const loginMutation = useMutation(
      (credentials) =>
        AuthService.login(credentials.email, credentials.password),
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries('AuthService.refreshUser');
          history.replace(ROUTES.ROOT);
        },
      }
    );

    const handleLoginPress = async ({ values, validationState }) => {
      if (!validationState.valid) {
        return;
      }
      await loginMutation.mutate(values);
    };

    const handleCreateAccountPress = useCallback(() => {
      history.push(ROUTES.CREATE_ACCOUNT);
    });
    const handleForgotPasswordPress = useCallback(() => {
      history.push(ROUTES.FORGOT_PASSWORD);
    });

    return {
      errorMessage: get(loginMutation, 'error.message'),
      handleForgotPasswordPress,
      handleLoginPress,
      handleCreateAccountPress,
    };
  },
});
